import React from 'react';
import Modal from 'react-bootstrap-modal';
import Dropzone from 'react-dropzone';
import { Dimmer, Loader, Progress } from 'semantic-ui-react';
import './fileSelectionModal.css';

export default class FileSelectionModal extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
			isOpen: false,
			isLoading: false,
            title: "",
			file: null,
			errors: null,
			dragOver: false,
            uploadProgress: null,
            openOptions: null,
            abortController: null,
            promiseResolve: null,
            promiseReject: null
        };
    }

    open(title, options) {
        let promise = new Promise((resolve, reject) => {
            this.setState({
				isOpen: true,
                isLoading: false,
                title: title,
				file: null,
                errors: null,
				dragOver: false,
                uploadProgress: null,
                openOptions: options || null,
                abortController: null,
                promiseResolve: resolve,
                promiseReject: reject
            });
        });
        return promise;
    }
	
	onDrop(files) {
		if(files && files.length > 0) {
			this.setState({
				file: files[0]
			});
		}
	}

    cancelActiveUpload() {
        if (this.state.abortController) {
            this.state.abortController.abort();
        }
        this.setState({
            isLoading: false,
            uploadProgress: null,
            abortController: null
        });
    }

    handleDismiss() {
        if (this.state.isLoading) {
            this.cancelActiveUpload();
            return;
        }
        this.close();
    }

	sendFile() {
        const { file, openOptions } = this.state;
        if (!file) {
            return;
        }

        if (openOptions && typeof openOptions.onSubmit === 'function') {
            const abortController = new AbortController();
            this.setState({
                isLoading: true,
                errors: null,
                uploadProgress: 0,
                abortController
            });

            openOptions.onSubmit(file, {
                onProgress: (percent) => this.setState({ uploadProgress: percent }),
                signal: abortController.signal
            })
                .then((result) => {
                    if (this.state.promiseResolve) {
                        this.state.promiseResolve(result);
                    }
                })
                .catch((err) => {
                    if (err && err.aborted) {
                        this.setState({
                            isLoading: false,
                            uploadProgress: null,
                            abortController: null
                        });
                        return;
                    }
                    const message = err && (err.Message || err.message || err.Error);
                    this.showError(message || 'Произошла ошибка при загрузке файла.');
                });
            return;
        }

        const resolve = this.state.promiseResolve;
        if (resolve) {
            resolve(file);
        }
        this.close();
	}

	showError(message) {
		this.setState({
            isLoading: false,
            uploadProgress: null,
            abortController: null,
			errors: message
		});
	}

    close() {
        if (this.state.isLoading) {
            this.cancelActiveUpload();
        }
        this.setState({
			isOpen: false,
            isLoading: false,
            title: "",
			file: null,
            errors: null,
			dragOver: false,
            uploadProgress: null,
            openOptions: null,
            abortController: null,
            promiseResolve: null,
            promiseReject: null
        });
    }

	renderDropzoneBody() {
		if (this.state.file == null) {
			return (
				<div className="dropzone-label">
                    <span>
                        Перенесите файл на эту область<br/><b>или</b><br/>нажмите для открытия диалога выбора файла.<br/>
                        <i style={{ lineHeight: '28px', fontSize: 'small' }}>(размер файла не более {this.state.openOptions && this.state.openOptions.maxFileSize || 10}MB)</i>
                    </span>
				</div>
			);
		} else {
			return (
				<div className="dropzone-label">
                    <img src="/img/file_icon.png" className="dropzone-icon" alt="file" />
					<span>{this.state.file.name}</span>
				</div>
			);
		}
	}

    renderUploadProgress() {
        const { isLoading, uploadProgress } = this.state;
        if (!isLoading || uploadProgress == null) {
            return null;
        }
        return (
            <div className="file-selection-modal__progress">
                <Progress percent={uploadProgress} indicating />
                <span className="file-selection-modal__progress-label">Загрузка: {uploadProgress}%</span>
            </div>
        );
    }

    renderErrors() {
        const { errors } = this.state;
        if (errors == null || errors === '') {
            return null;
        }
        const items = Array.isArray(errors) ? errors : [errors];
        const lines = items
            .map((e) => (typeof e === 'string' ? e : String(e)))
            .filter((s) => s.length > 0);
        if (lines.length === 0) {
            return null;
        }
        return (
            <div className="file-selection-modal__errors" role="alert">
                <div className="alert alert-danger">
                    {lines.length === 1 ? (
                        lines[0]
                    ) : (
                        <ul className="file-selection-modal__errors-list">
                            {lines.map((line, i) => (
                                <li key={i}>{line}</li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        );
    }

    render() {
        const { isLoading, file, dragOver } = this.state;
		let dragzoneClass =
            'dropzone has-advanced-upload' +
            (dragOver && !isLoading ? ' is-dragover' : '') +
            (isLoading ? ' dropzone--disabled' : '');
        const cancelLabel = isLoading ? 'Прервать загрузку' : 'Отмена';
        return (
            <Modal show={this.state.isOpen} 
				onHide={() => this.handleDismiss()} 
				aria-labelledby="ModalHeader" 
				backdrop="static"
			>
                <Modal.Header closeButton>
                    <Modal.Title id='ModalHeader'>
						{this.state.title}
					</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="file-selection-modal__body">
                        <Dimmer active={isLoading && this.state.uploadProgress == null} inverted>
                            <Loader size="medium" />
                        </Dimmer>
                        <Dropzone
                            multiple={false}
                            disabled={isLoading}
                            onDrop={(files) => this.onDrop(files)}
                            styles={{}}
                            className={dragzoneClass}
                            onDragEnter={() => !isLoading && this.setState({ dragOver: true })}
                            onDragLeave={() => this.setState({ dragOver: false })}
                        >
                            {this.renderDropzoneBody()}
                        </Dropzone>
                        {this.renderUploadProgress()}
                        {this.renderErrors()}
                    </div>
                </Modal.Body>
                <Modal.Footer>
					<button
                        type="button"
                        className="btn btn-primary"
						onClick={() => this.sendFile()}
						disabled={file == null || isLoading}
					>
						Отправить
					</button>
                    <button
                        type="button"
                        className="btn btn-default"
                        onClick={() => this.handleDismiss()}
                    >
						{cancelLabel}
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./App/modals/fileSelectionModal.jsx